import fs from 'node:fs'
import { snapshotTargetPath } from '@core-engine/snapshots/store/snapshot-target-path.js'

export function deleteProjectFile(cwd: string, filePath: string): void {
  fs.rmSync(snapshotTargetPath(cwd, filePath), { force: true })
}
